const dict = {
  en: { welcome: "Welcome to TRO", signin: "Sign In", create: "Create Account", forgot: "Forgot Password" },
  fr: { welcome: "Bienvenue sur TRO", signin: "Se connecter", create: "Créer un compte", forgot: "Mot de passe oublié" },
  pt: { welcome: "Bem-vindo ao TRO", signin: "Entrar", create: "Criar conta", forgot: "Esqueceu a senha" },
  es: { welcome: "Bienvenido a TRO", signin: "Iniciar sesión", create: "Crear cuenta", forgot: "Olvidé mi contraseña" },
  ar: { welcome: "مرحبًا بك في TRO", signin: "تسجيل الدخول", create: "إنشاء حساب", forgot: "نسيت كلمة المرور" },
};
export const LANGS = [["en", "English"], ["fr", "Français"], ["pt", "Português"], ["es", "Español"], ["ar", "العربية"]];
export const getLang = () => localStorage.getItem("tro_lang") || "en";
export const setLang = (l) => {
  localStorage.setItem("tro_lang", l);
  document.documentElement.dir = l === "ar" ? "rtl" : "ltr";
};
export const t = (k) => dict[getLang()]?.[k] || dict.en[k] || k;
